export default __webpack_public_path__ + "static/media/BankImage.dec256ec.svg";